import { CalendarDays, Flag, FolderKanban, Timer } from "lucide-react";
import { Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const formatDate = (value) => {
  if (!value) {
    return "-";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "-";
  }

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(parsed);
};

const statusVariantMap = {
  planning: "secondary",
  active: "success",
  completed: "primary",
  archived: "dark",
};

const ProjectItem = ({ project }) => {
  const navigate = useNavigate();

  const handleProjectClick = () => {
    if (!project?.id) {
      return;
    }

    navigate(`/projects/${project.id}`, { state: project });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleProjectClick();
    }
  };

  const projectName = project?.name || "Untitled project";
  const projectStatus = String(project?.status || "planning").toLowerCase();
  const projectType = project?.project_type || "-";

  // Sum up work package ETIs inside this project
  const workPackagesSum = project?.work_packages && Array.isArray(project.work_packages) && project.work_packages.length > 0
    ? project.work_packages.reduce((sum, wp) => sum + Number(wp.etis || 0), 0)
    : 0;

  // Fallback logic: Use explicit estimated_etis if greater than 0, otherwise use the work package sum
  const displayEtis = Number(project?.estimated_etis) > 0 
    ? Number(project.estimated_etis) 
    : workPackagesSum;

  return (
    <article
      className="project-card project-card-interactive h-100"
      role="button"
      tabIndex={0}
      onClick={handleProjectClick}
      onKeyDown={handleKeyDown}
      aria-label={`Open project ${projectName}`}
    >
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div className="d-flex align-items-center gap-2">
          <FolderKanban size={18} />
          <h5 className="mb-0 project-card-title">{projectName}</h5>
        </div>
        <Badge bg={statusVariantMap[projectStatus] || "secondary"}>{project?.status || "Planning"}</Badge>
      </div>

      <p className="project-card-subtitle mb-3">{projectType}</p>

      <div className="project-card-metadata">
        <div className="project-card-meta-row">
          <CalendarDays size={14} />
          <span>
            {formatDate(project?.start_date)} - {formatDate(project?.end_date)}
          </span>
        </div>
        <div className="project-card-meta-row">
          <Timer size={14} />
          <span>{displayEtis} ETIs</span>
        </div>
        <div className="project-card-meta-row">
          <Flag size={14} />
          <span>{project?.priority || "Medium"} Priority</span>
        </div>
      </div>
    </article>
  );
};

export default ProjectItem;